import React from "react";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";

import UseWindowDimensions from "../../../utils/windowSize";

const UnderConstructionPage = () => {
  const { height } = UseWindowDimensions();

  return (
    <Box
      sx={{
        display: "flex",
        height: height + "px",
        alignItems: "end",
        backgroundColor: "white.main",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box sx={{ px: "16px", mt: "170px", textAlign: "center" }}>
          <Typography
            sx={{
              fontSize: "64px",
              fontWeight: 700,
              fontFamily: "Tahrir",
              lineHeight: "40px",
              mb: "16px",
            }}
          >
            AZAD
          </Typography>
          <Typography
            sx={{
              fontWeight: 500,
              fontFamily: "Tahrir",
              fontSize: "40px",
              lineHeight: "40px",
            }}
          >
            Is Under Construction
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "24px 16px 16px 16px",
            mt: "auto",
            mb: "34px",
          }}
        >
          <Typography
            sx={{
              fontSize: "18px",
              lineHeight: "28px",
            }}
          >
            Sorry! We are doing some work on the app to make it better for your
            ideas. Please check back in the next 30 minutes.
          </Typography>
          <Typography
            sx={{
              fontSize: "18px",
              lineHeight: "28px",
              mt: "48px",
              mb: "25px",
            }}
          >
            You can check out our social media during this period.
          </Typography>
          <Box
            sx={{
              display: "inline-flex",
              justifyContent: "center",
            }}
          >
            <InstagramIcon sx={{ fontSize: "32px", mx: "15px" }} />
            <TwitterIcon sx={{ fontSize: "32px", mx: "15px" }} />
            <LinkedInIcon sx={{ fontSize: "32px", mx: "15px" }} />
            <YouTubeIcon sx={{ fontSize: "32px", mx: "15px" }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default UnderConstructionPage;
